import React from "react";
import { Box, Typography, useMediaQuery, useTheme, Button } from "@mui/material";
import { ArrowForward } from "@mui/icons-material";

const Hero = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const heroContent = {
    title: "Join Us",
    description: "Your career is a journey, not a destination. Join us for an incredible adventure!",
  };

  return (
    <>
     <link 
  rel="preload" 
  as="image" 
  href="/joinHeroSection-480w.webp" 
  media="(max-width: 767px)"
  fetchpriority="high" 
/>
<link 
  rel="preload" 
  as="image" 
  href="/joinHeroSection-768w.webp" 
  media="(min-width: 768px) and (max-width: 1199px)"
  fetchpriority="high" 
   type="image/webp"
/>
<link 
  rel="preload" 
  as="image" 
  href="/joinHeroSection.webp" 
  media="(min-width: 1200px)"
  fetchpriority="high" 
/>
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
      }}
    >
      <Box
        component="section"
        sx={{
          position: "relative",
          width: "95%",
          height: isMobile ? "300px" : "500px",
          overflow: "hidden",
          backgroundColor: "#fff",
          borderRadius: "8px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {/* Background Image with WebP and Responsive Sizes */}
        <Box
          component="picture"
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 0,
          }}
        >
          <source
    srcSet={`
      /joinHeroSection-480w.webp 480w,
      /joinHeroSection-768w.webp 768w,
      /joinHeroSection.webp 1200w,
      /joinHeroSection.webp 1920w
    `}
    sizes="100vw"
    type="image/webp"
  />
  <source
    srcSet={`
      /joinHeroSection-480w.jpg 480w,
      /joinHeroSection-768w.jpg 768w,
      /joinHeroSection-1200w.jpg 1200w,
      /joinHeroSection.jpg 1920w
    `}
    sizes="100vw"
    type="image/jpeg"
  />
  {/* Fallback image */}
  <Box
    component="img"
    src="/joinHeroSection.jpg"
    alt="People collaborating"
    sx={{
      width: "100%",
      height: "100%",
      objectFit: "cover",
    }}
    loading="eager"
    fetchpriority="high"
    decoding="sync"
    width={isMobile ? 480 : 1200}
    height={isMobile ? 300 : 500}
  />
        </Box>

        {/* Background Overlay with Diagonal Gradient */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background:
              "linear-gradient(135deg, rgba(0, 0, 0, 0.86) 0%, rgba(10, 10, 10, 0.48) 100%)",
            zIndex: 1,
          }}
        />

        {/* Centered Content */}
        <Box
          sx={{
            position: "absolute",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 2,
            textAlign: "center",
            padding: "20px",
          }}
        >
          {/* Title */}
          <Typography
            variant="h2"
            sx={{
              fontSize: isMobile ? "52px" : "72px",
              color: "#fff",
              fontWeight: "bold",
              marginBottom: "10px",
            }}
          >
            {heroContent.title}
          </Typography>

          {/* Description */}
          <Typography
            sx={{
              fontSize: isMobile ? "25px" : "30px",
              color: "#fff",
              fontWeight: 300,
            }}
          >
            {heroContent.description}
          </Typography>
          <Button
            onClick={() => {
              const rolesSection = document.getElementById("open-roles-section");
              if (rolesSection) {
                rolesSection.scrollIntoView({ behavior: "smooth" });
              }
            }}
            variant="outlined"
            aria-label="View Open Roles"
            sx={{
              borderRadius: "50px",
              border: "2px solid #fff",
              color: "#fff",
              padding: "10px 20px",
              textTransform: "none",
              fontSize: "18px",
              display: "inline-flex",
              alignItems: "center",
              gap: "8px",
              marginTop: "20px",
              cursor: "pointer",
              transition:
                "background-color 0.3s ease-in-out, color 0.3s ease-in-out",
              "&:hover": {
                color: "#FFFFFFD9",
              },
              "&:hover .MuiSvgIcon-root": {
                transform: "translateX(-5px)",
                opacity: 1,
                transition:
                  "transform 0.3s ease-in-out, opacity 0.3s ease-in-out",
              },
              "&:hover .text": {
                transform: "translateX(3px)",
                transition: "transform 0.3s ease-in-out",
              },
            }}
          >
            <Typography
              className="text"
              sx={{
                transition: "transform 0.3s ease-in-out",
                fontWeight: 380,
                fontSize: "18px",
              }}
            >
              Open Roles
            </Typography>
            <ArrowForward
            aria-hidden="true"
              sx={{
                transition:
                  "transform 0.3s ease-in-out, opacity 0.3s ease-in-out",
              }}
            />
          </Button>
        </Box>
      </Box>
    </Box></>
  );
};

export default Hero;